import DetailsPageHeader from '../../components/DetailsPageHeader';
import ServiceDetailsForm from '../../components/manager/ServiceDetailsForm';
import OwnerSidebar from '../../components/owner/OwnerSidebar';


const OwnerServicesDetailsScreen = () => {


  return (
    <>
        <section className='dashboard-container flex '>
        <aside className=''>
            <OwnerSidebar />
        </aside>
        <main className='main-container mb-32'>
            <DetailsPageHeader pageName={'Services'} customerDetails={'Wash N Fold'} showServicesButton={true}/>
            <section className='mt-10 flex gap-5'>
                <div className=''>
                    <div className='laundry-details-title-items gap-10'>
                        <div className='services-details-title-section flex flex-col gap-4'>
                            <p className='services-details-title-text'>Wash N Fold</p>
                            <p className='services-details-subtitle-text'>$ 10.00 <span> per .lbs</span></p>
                        </div>
                        <section className='order-details-more-options'>
                                <div className='order-status-option-dropdown services-details-status-option-dropdown flex ml-32'>
                                    <select className='mt-6'>
                                        <option value="option1">More options</option>
                                        <option value="option2">Archive Service</option>
                                    </select>
                                    
                                </div>
                        </section>
                        
                    </div>
                    
                </div>
            </section>
            <section className='flex gap-4 service-form-section'>
                <section>
                    <ServiceDetailsForm />

            </section>
           
          </section>
        </main>
      </section>
    </>
  )
}

export default OwnerServicesDetailsScreen